export const convertKeysToCamelCase = (obj) => {
  const toCamelCase = str => str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

  return Object.keys(obj).reduce((acc, key) => {
      acc[toCamelCase(key)] = obj[key];
      return acc;
  }, {});
}